<template>
  <transition name="fade">
    <div class="modal" v-if="show" v-on:click.stop="modalClicked">
      <div class="modalOverlay"></div>
      <div :class="{modalContent: true, hasCheck: checkbox}">
        <h4 v-html="title"></h4>
        <p v-html="desc"></p>
        <div class="checkCnt" v-on:click="checked = !checked" v-if="checkbox">
          <div class="checkboxOuter">
            <div :class="{checkbox: true, checked: checked}">
              <div class="checkInner"></div>
            </div>
          </div>
          <p>{{checkbox}}</p>
        </div>
        <div class="fieldGroup" v-for="(item, i) in inputs" :key="`inpt${i}`">
          <label v-if="item.label">{{item.label}}</label>
          <textarea rows="2" class="field" :placeholder="item.placeholder || item.label"
            v-model="item.value[lang]" ref="inputs" v-if="item.type === 'longtext'"></textarea>

          <div class="mediaCnt" v-if="item.type === 'media'">
            <div class="field" v-on:click="addImage(item)" ref="inputs">
              <div class="fieldImg" v-if="item.value && item.value[lang]"
                :style="{'background-image': `url(${item.value[lang].imageSm})`}"></div>
              <div class="fieldImg noImg" v-else></div>
              <div class="mediaLabel" v-if="item.value && item.value[lang]
                && item.value[lang].name">
                {{item.value[lang].name}}</div>
              <div class="mediaLabel" v-else-if="item.value && item.value[lang]">
                Selected Media</div>
              <div class="mediaLabel" v-else>Select Media</div>
              <div class="fieldMore" v-if="item.value && item.value[lang]"
                v-on:click.stop="item.value[lang] = null"></div>
            </div>
          </div>

          <input :type="item.type" class="field" :placeholder="item.placeholder || item.label"
            v-model="item.value[lang]" ref="inputs" v-else>
          <div class="fieldHint" v-if="item.helper">{{item.helper}}</div>
        </div>
        <div class="fieldGroup" v-if="input">
          <input type="text" class="field" :placeholder="input"
            v-model="inputValue" ref="input">
          <div class="fieldHint" v-if="inputHelper">{{inputHelper}}</div>
        </div>
        <div class="modalAction" v-if="error">
          <button class="btn btnSecondary" v-on:click="close()"
            ref="btnPrimary">
            <span v-if="action">{{action}}</span>
            <span v-else>Close</span>
          </button>
        </div>
        <div class="modalAction" v-else>
          <div class="langSelectorBtn" v-if="multiLang"
            v-on:click.stop="langSelectorOpen = !langSelectorOpen">
            <b>{{lang}}</b>
            <div class="langSelector" v-if="langSelectorOpen"
              v-on:click.stop="doNothing">
              <li v-on:click.stop="selectLang('en')">EN - English</li>
              <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
            </div>
          </div>
          <button class="btn btnSecondary" v-on:click="close()">Cancel</button>
          <button class="btn btnPrimary" v-on:click="close(true)" ref="btnPrimary">
            <span v-if="action">{{action}}</span>
            <span v-else>Delete</span>
          </button>
        </div>
      </div>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'confirmation',
  components: { MediaSelector },
  data() {
    return {
      show: false,
      title: '',
      desc: '',
      action: '',
      input: '',
      inputValue: '',
      inputHelper: '',
      inputs: [],
      checkbox: null,
      checked: false,
      next: null,
      error: false,
      multiLang: false,
      lang: 'id',
      langSelectorOpen: false,
    };
  },
  methods: {
    modalClicked() {
      this.langSelectorOpen = false;
    },
    keyPressed(e) {
      if (!this.show) return;
      if (e.key === 'Escape') {
        this.close(false);
      }
    },
    addImage(item) {
      this.$refs.mediaSelector.open(null, (b, m) => {
        if (!b) return;
        const media = m && m.gallery ? m.gallery[0] : m;
        item.value[this.lang] = media;
      });
    },
    selectLang(lang) {
      this.langSelectorOpen = false;
      this.lang = lang;
    },
    open(d, next) {
      this.show = true;
      this.next = next;
      this.title = d.title;
      this.desc = d.desc;
      this.checkbox = d.checkbox;
      this.action = d.action;
      this.error = d.error;
      this.checked = d.checked;
      this.input = d.input;
      this.inputHelper = d.inputHelper;
      this.inputValue = '';
      this.inputs = d.inputs || [];
      this.multiLang = d.multiLang;
      this.lang = d.lang || 'id';
      setTimeout(() => {
        if (this.inputs.length > 0) this.$refs.inputs[0].focus();
        else if (this.input) this.$refs.input.focus();
        else this.$refs.btnPrimary.focus();
      });
    },
    close(b) {
      this.show = false;
      const checked = (this.checked) ? JSON.parse(JSON.stringify(this.checked)) : null;
      const inputValue = this.inputValue ? JSON.parse(JSON.stringify(this.inputValue)) : null;
      const inputs = this.inputs ? JSON.parse(JSON.stringify(this.inputs)) : null;
      if (this.next && typeof this.next === 'function') this.next(b, checked, inputValue, inputs);
    },
  },
  created() { window.addEventListener('keydown', this.keyPressed); },
  destroyed() { window.removeEventListener('keydown', this.keyPressed); },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      width: 320px;
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .fieldGroup{
        margin: 20px 0 0;
      }
      .mediaCnt{
        .field{
          cursor: pointer;
          padding: 18px 40px 19px;
          padding-left: 64px;
          position: relative;
          .mediaLabel{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 600;
            font-size: 17px;
          }
          .fieldImg{
            content: "";
            position: absolute;
            width: 46px; height: 46px;
            background-color: #eee;
            border-radius: 5px;
            left: 6px; top: 6px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            &.noImg{
              background-color: #ccc;
              background-image: url(../assets/image-black.png);
              background-size: 22px auto;
              opacity: .36;
              &.video{
                background-image: url(../assets/video-black.png);
              }
            }
          }
          .fieldMore{
            position: absolute;
            right: 8px; top: 11px;
            width: 34px; height: 34px;
            border-radius: 50%;
            background-size: 12px auto;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(../assets/close.png);
            opacity: .36;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{
              background-color: #ccc;
              opacity: .64;
            }
          }
        }
      }
      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 20px;
        text-align: right;
        display: flex;
        align-items: center;
        .langSelectorBtn{
          margin-right: auto;
          position: relative;
          border-radius: 50px;
          padding: 6px 16px;
          padding-left: 36px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover{
            background-color: #f5f5fe;
          }
          &:before{
            content: "";
            position: absolute;
            left: 12px; top: 0; bottom: 3px;
            width: 18px;
            background-image: url(../assets/language.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          b{
            font-weight: 600;
            text-transform: uppercase;
          }
          .langSelector{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            bottom: 100%; left: 0;
            box-shadow: 0 0 6px rgba(0, 0, 0, .2);
            border-radius: 5px;
            padding: 8px 0;
            text-align: left;
            li{
              white-space: nowrap;
              list-style: none;
              padding: 8px 24px;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .btn{
          margin-left: 10px;
          &.btnSecondary{
            margin-left: auto;
          }
        }
      }
    }
  }
</style>
